import * as React from "react";
import "./close-cross.scss";

interface CloseCrossProps {
  size?: "8" | "12" | "14" | "16" | "18" | "20" | "24";
  onClick?: () => void;
  className?: string;
}

const DEFAULT_PROPS: CloseCrossProps = {
  size: "20",
  onClick: () => {},
  className: "",
};

export const CloseCross: React.FC<CloseCrossProps> = ({ size, onClick, className }) => (
  <div
    className={`c-close-cross c-close-cross--size-${size || DEFAULT_PROPS.size} ${
      className || DEFAULT_PROPS.className
    }`}
    onClick={onClick || DEFAULT_PROPS.onClick}
    title="cross icon"
  >
    <svg viewBox="0 0 40 40" version="1.1" xmlns="http://www.w3.org/2000/svg">
      <g id="cross" transform="translate(-660.000000, -190.000000)" fill="#000000">
        <polygon
          id="cross"
          points="697.5 190 700 192.5 682.5 210 700 227.5 697.5 230 680 212.5 662.5 230 660 227.5 677.5 210 660 192.5 662.5 190 680 207.5"
        />
      </g>
    </svg>
  </div>
);
